// extracted by mini-css-extract-plugin
export default {"modalOverlay":"iJ-z","modalContent":"jJ-z","header":"kJ-z","close":"lJ-z"};